import React from "react";
import { Box, Typography, Button } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const PlacedOrderAnimation = () => {
    const keyframes = `
    @keyframes popIn {
      0% {
        transform: scale(0.5);
        opacity: 0;
      }
      60% {
        transform: scale(1.1);
        opacity: 1;
      }
      100% {
        transform: scale(1);
      }
    }
  `;

    const navigate = useNavigate()

    return (
        <>
            {/* Inject keyframes into page */}
            <style>{keyframes}</style>

            <Box
                sx={{
                    minHeight: "60vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "2rem",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "16px",
                    "& svg": {
                        fontSize: "80px",
                        color: "#4caf50",
                        animation: "popIn 0.6s ease-out",
                    },
                }}
            >
                <FaRegCheckCircle />

                <Typography
                    variant="h4"
                    sx={{
                        marginTop: "16px",
                        fontWeight: "bold",
                        color: "#333",
                        animation: "popIn 0.6s ease-out 0.2s both",
                    }}
                >
                    Order Placed!
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        marginTop: "8px",
                        color: "#666",
                        animation: "popIn 0.6s ease-out 0.4s both",
                    }}
                >
                    Thank you for shopping with us. You’ll receive a confirmation shortly.
                </Typography>

                <Button
                    variant="contained"
                    color="primary"
                    sx={{
                        marginTop: "24px",
                        padding: "10px 24px",
                        animation: "popIn 0.6s ease-out 0.6s both",
                    }}
                    onClick={() => navigate("/orders")}
                >
                    View My Orders
                </Button>
            </Box>
        </>
    );
};

export default PlacedOrderAnimation;
